import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { App } from './app'
import { init } from './i18n'

import './styles.css'

// Initialize i18n before rendering
init().then(() => {
  const rootElement = document.getElementById('app')
  if (rootElement && !rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement)
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    )
  }
})
